export default {
    add: 'Add new post',
    empty: {
        posts: {
            first: 'Add first post',
            title: 'Looking for content?',
            content: 'Unfortunately, there is nothing to see here yet.<br />Create a post!'
        },
        macrotrends: {
            first: 'Go to trend finder',
            title: 'Add macro trends',
            content:
        'Macro-trends have not been assigned to the innovation field yet. ' +
        'To continue, please use the trend finder and select the appropriate macro-trends.'
        }
    }
}
